import { theme } from 'antd';
import { useSelector } from 'react-redux';
import useThemeDetector from './useThemeDetector';
import { isDarkThemeMode } from '../theme/themeMode';

const { useToken } = theme;

export default function useMyTheme() {
  const selectedTheme = useSelector((state) => {
    return state.currentUser?.themeMode;
  });

  const { systemTheme } = useThemeDetector();

  const { token } = useToken();

  const isDark =
    selectedTheme === 'system'
      ? systemTheme === 'dark'
      : isDarkThemeMode(selectedTheme);

  return { theme: selectedTheme, isDark, token };
}
